module.exports = __webpack_public_path__ + "img/covertex-thumb.577246f0.jpg";